/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */
document.addEventListener("DOMContentLoaded", function () {
    const shopPayLoginButton = document.querySelector(".shopify-block.shopify-app-block");
   $("[data-nametag='shop-portal-provider']").hide();
  if (shopPayLoginButton) {
    shopPayLoginButton.addEventListener('click',function () {
      console.log('click')
      $("[data-nametag='shop-portal-provider']").show();
    })
  }
 // Lazyload Videos
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));
  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
  
// Function to update the <a> element text content
function updateLinkText() {
    const rhPasswordlessLogin = document.getElementById("rc_login");
  // console.log("Running")
    if (rhPasswordlessLogin) {


        // Find the <p> element inside rhPasswordlessLogin
        const pElement = rhPasswordlessLogin.querySelector('p');

        // Check if the <p> element exists and has a child <a> element
        if (pElement) {
            const aElement = pElement.querySelector('a');
            
            // Check if the <a> element exists
            if (aElement) {
                // Change the text content of the <a> element
              
                aElement.textContent = 'Passwordless Login';
                clearInterval(interval); // Stop the interval once text is updated
            } else {
                // console.log('Child <a> element not found inside <p> element.');
            }
        } else {
            // console.log('Child <p> element not found inside rhPasswordlessLogin.');
        }
    } else {
        // console.log("rhPasswordlessLogin element not found.");
    }
}

// Interval to check for the element periodically
  if(window.theme.currentPage.includes('login')){
      var interval = setInterval(updateLinkText, 1000); // Check every 1000ms (1 second)
  }

  //End Test
  //Timeline click to scroll to element

  // Select all elements with the class 'timeline__inner'
  const timelineInners = document.querySelectorAll(".timeline__inner");

  // Iterate over each 'timeline__inner' element
  timelineInners.forEach(function (timelineInner) {
    // Select all timeline__row elements within the current timeline__inner
    const timelineRows = timelineInner.querySelectorAll(".timeline__row");
    const containerWidth = timelineInner.clientWidth;
    const indicatorLine = timelineInner.querySelector(
      ".timeline__indicator__line"
    );
    const totalWidth = timelineRows.length * timelineRows[0].offsetWidth;
    // Add click event listener to each timeline__row within the current timeline__inner
    timelineRows.forEach(function (row, index) {
      row.addEventListener("click", function () {
        // Calculate the desired scroll position to center the clicked row
        let scrollTo;
        if (index === timelineRows.length - 1 && window.innerWidth > 1300) {
          // If the clicked row is the last one and the screen width is larger than 1300px, scroll to the end
          scrollTo = timelineInner.scrollWidth;
        } else {
          // Otherwise, calculate the scroll position to center the clicked row
          const clickedRowOffset = row.offsetLeft; // Left offset of the clicked row relative to the container
          const containerWidth = timelineInner.offsetWidth; // Width of the container
          scrollTo =
            clickedRowOffset - containerWidth / 2 + row.offsetWidth / 2;
        }

        // Ensure the scroll position stays within the bounds of the scrollable area
        scrollTo = Math.max(0, scrollTo);

        // Scroll the container to the desired position with smooth scrolling
        timelineInner.scrollTo({
          left: scrollTo,
          behavior: "smooth",
        });
      });
    });

    timelineInner.addEventListener("scroll", () => {
      if (
        timelineInner.scrollLeft ===
        timelineInner.scrollWidth - timelineInner.clientWidth
      ) {
        // Scroll has reached the end, apply width: 40% to timeline__indicator__line
        indicatorLine.style.width = "40%";
      } else {
        // Scroll has not reached the end, reset width to default or any other value
        indicatorLine.style.width = ""; // Resets width to default
      }
    });
  });

  // Sliders Custom
  // Check if any .flickity-enabled-custom element exists
  const initSliders = () => {
   const flickityEnabledContainers = document.querySelectorAll(
    ".flickity-enabled-custom"
  );
  
  if (flickityEnabledContainers.length > 0) {
    flickityEnabledContainers.forEach((container) => {
      // Find the .flickity__container-custom element within the current container
      const slideContainer = container.querySelector(
        ".flickity__container-custom"
      );
      
      if (!slideContainer) return; // Skip if the slide container is not found
      // Find the .flickity-page-dots-custom element within the current container
      const dotContainer = container.querySelector(
        ".flickity-page-dots-custom"
      );
      if (!dotContainer) return; // Skip if the dot container is not found

      let lastStyledButton = null; // Variable to store the previously styled button

      // Create a new Intersection Observer
      const observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry, forIndex) => {
            if (entry.intersectionRatio >= 0.1) {
              // If the entire slide is in the viewport, add the 'slide-is-visible' class
              entry.target.classList.add("slide-is-visible");
              // Get the data-slide-position attribute value
              const slidePosition = entry.target.getAttribute(
                "data-slide-position"
              );
              
              if (slidePosition) {
                // Find the button with the matching data-dot-position attribute
                const button = dotContainer.querySelector(
                  `.flickity-page-dot[data-dot-position="${slidePosition}"]`
                );
                
                if (button) {
                  // Remove the 'flickity-dot-styling' class from the previously styled button
                  if (lastStyledButton) {
                    lastStyledButton.classList.remove("flickity-dot-styling");
                  }
                  
                  // Add the 'flickity-dot-styling' class to the current button
                  button.classList.add("flickity-dot-styling");
                  // Update the lastStyledButton to the current button
                  lastStyledButton = button;
                }
              }
            } else {
              // If the slide is not fully in the viewport, remove the 'slide-is-visible' class
              entry.target.classList.remove("slide-is-visible");
              // Get the data-slide-position attribute value
              const slidePosition = entry.target.getAttribute(
                "data-slide-position"
              );
              if (slidePosition) {
                // Find the button with the matching data-dot-position attribute
                const button = dotContainer.querySelector(
                  `.flickity-page-dot[data-dot-position="${slidePosition}"]`
                );
                if (button) {
                  // Remove the 'flickity-dot-styling' class from the button
                  button.classList.remove("flickity-dot-styling");
                  // If this button is the lastStyledButton, reset the lastStyledButton to null
                  if (button === lastStyledButton) {
                    lastStyledButton = null;
                  }
                }
              }
            }
          });
        },
        {
          threshold: [0.85], // Trigger the callback
        }
      );

      // Observe each slide item within the slide container
      const slideItems = slideContainer.querySelectorAll(
        ".flickity_item_container-custom"
      );
      slideItems.forEach((item) => {
        observer.observe(item);
      });

      // Add event listener to each button within this container
      const buttons = dotContainer.querySelectorAll(".flickity-page-dot");
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          const slidePosition = button.getAttribute("data-dot-position");
          if (slidePosition) {
            const slide = slideContainer.querySelector(
              `.flickity_item_container-custom[data-slide-position="${slidePosition}"]`
            );

            if (slide) {
              // Scroll to the corresponding slide within this container
              const newPosition = slide.offsetLeft;

              slideContainer.scroll({
                left: newPosition,
                behavior: "smooth", // Smooth scrolling effect
              });
            }
          }
        });
      });
    });
  }   
  }
  initSliders();
    // Function to observe changes in the complementary-products element
    function observeComplementaryProducts() {
        const targetNode = document.querySelector('.complementary-products');

        if (!targetNode) {
            // console.error("complementary-products element not found");
            return;
        }

        const config = { childList: true, subtree: true };

        const callback = function(mutationsList, observer) {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    initSliders();
                    // If you only want to run initSliders once, you can disconnect the observer here
                    observer.disconnect();
                }
            }
        };

        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);

    }

    // Call the function to set up the observer
    observeComplementaryProducts();
});
//Header
// Variable to store the last scroll position
var lastScrollTop = 0;

// Event listener to update the last scroll position and check if the user scrolled up
$(window).scroll(function (event) {
  var currentScrollTop = window.scrollY;
  // Check if the user scrolled up
  if (currentScrollTop < lastScrollTop) {
    // Check if the user is at the top of the viewport
    if (currentScrollTop === 0) {
      // Check if the header has the js__header__stuck class
      if ($(".header__wrapper").hasClass("js__header__stuck")) {
        // Check if the user is at the top of the document
        if (document.documentElement.scrollTop === 0) {
          // Remove the js__header__stuck class from the header

          $(".header__wrapper").removeClass("js__header__stuck");
        }
      }
    }
  }
  // Update the last scroll position
  lastScrollTop = currentScrollTop;
});

(function () {
  // Hide Header on on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  // var navbarHeight = $(".header__wrapper").outerHeight();
  var navbarHeight = $(".theme__header").outerHeight();

  $(window).scroll(function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 50);

  function hasScrolled() {
    var st = $(this).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta) return;
    if (st > lastScrollTop && st > navbarHeight) {
      $(".header__wrapper").removeClass("js__header__stuck");
    } else if (st === 0 || st < navbarHeight) {
      $(".header__wrapper").removeClass("js__header__stuck");
    } else {
      if (st + $(window).height() < $(document).height()) {
        $(".header__wrapper").addClass("js__header__stuck");
      }
    }
    lastScrollTop = st;
  }

  $(".header__mobile__hamburger").click(function () {
    if ($(".header__wrapper").hasClass("js__header__stuck")) {
      $(".header__wrapper").removeClass("js__header__stuck");
    }
  });

  $(".sliderow").click(function () {
    $(this).toggleClass("is-active");
    $(this).siblings(".mobile__menu__dropdown").toggleClass("is-visible");
    let slideRule = $(this)
      .siblings(".mobile__menu__dropdown")
      .data("sliderule");
    let parentMenu = $(this).parents(".drawer__menu").get(0);
    if (parentMenu.dataset.sliderulePane < slideRule) {
      parentMenu.dataset.sliderulePane = slideRule;
    }
  });

  $("#levelGuideBtn").on("click", function () {
    const levelGuidePopUp = document.getElementById("level-guide-pop-up");
    if (levelGuidePopUp) {
      levelGuidePopUp.click();
    }
  });
})();

// Recharge Widget initialisation in Theme Quick View
document.addEventListener("theme:quick-add:open", initCustomRecharge);

function initCustomRecharge() {
  let openedModals = document.querySelectorAll(".product-quick-add");
  const currentModal = openedModals[openedModals.length - 1];
  const subscriptionJson = JSON.parse(currentModal.querySelector('[data-product-subscription]').textContent);
  const productForm = currentModal.querySelector("form#product-form-upsell-api-product-upsell-" + currentModal.dataset.productId);
  const initialSellingPlanId = subscriptionJson.initialSellingPlanId;

  if (productForm.querySelector('input[name="selling_plan"]') != null) {
    productForm.querySelector('input[name="selling_plan"]').value = subscriptionJson.initialSellingPlanId;
  } else {
     if (productForm.querySelectorAll('input[name="selling_plan"]').length == 0) {
        var selling_plan_input1 = document.createElement("input");
        selling_plan_input1.setAttribute('type', 'hidden');
        selling_plan_input1.setAttribute('name', 'selling_plan');
        selling_plan_input1.value = initialSellingPlanId;
        productForm.appendChild(selling_plan_input1);
      } 
  }

  // Update CTA prices and suscription interval text
  let selected_variant_data = subscriptionJson.formattedVariantPrices.filter((el) => el.hasOwnProperty(subscriptionJson.initialVariantId))[0][subscriptionJson.initialVariantId];
  let selected_subscription_plan = selected_variant_data.formattedSellingPlanPrices.filter((sub) => sub.hasOwnProperty(subscriptionJson.initialSellingPlanId))[0][subscriptionJson.initialSellingPlanId]
  productForm.querySelector("#addToCartPrice").innerHTML = `<s>${selected_variant_data.priceWithoutTrailingZeros}</s>${selected_subscription_plan.discountedWithoutTrailingZeros}`;

  // Purchase option changes
  const purchaseOptions = currentModal.querySelectorAll('input[name="purchaseOption"]');
  purchaseOptions.forEach(input => {
    input.addEventListener('change', (evt) => {
      let currentVariant = currentModal.querySelector('input[name="id"]').value;
      let selected_variant_data = subscriptionJson.formattedVariantPrices.filter((el) => el.hasOwnProperty(currentVariant))[0][currentVariant];
      let currentSubscriptionPlan = Object.keys(selected_variant_data.formattedSellingPlanPrices[0])[0];
      let selected_subscription_plan = selected_variant_data.formattedSellingPlanPrices.filter((sub) => sub.hasOwnProperty(currentSubscriptionPlan))[0][currentSubscriptionPlan];
      if (productForm.querySelectorAll('input[name="selling_plan"]').length == 0) {
        var selling_plan_input1 = document.createElement("input");
        selling_plan_input1.setAttribute('type', 'hidden');
        selling_plan_input1.setAttribute('name', 'selling_plan');
        selling_plan_input1.value = currentModal.querySelector('input[name="purchaseOption"]:checked').value == 'subscription' ? currentSubscriptionPlan : null;
        productForm.appendChild(selling_plan_input1);
      } else {
        productForm.querySelector('input[name="selling_plan"]').value = currentModal.querySelector('input[name="purchaseOption"]:checked').value == 'subscription' ? currentSubscriptionPlan : null;
      }
       
      if (productForm.querySelector('input[name="selling_plan"]') != null && productForm.querySelector('input[name="selling_plan"]').value == '') {
        productForm.querySelector("#addToCartPrice").innerHTML = `${selected_variant_data.priceWithoutTrailingZeros}`;
      } else {
        productForm.querySelector("#addToCartPrice").innerHTML = `<s>${selected_variant_data.priceWithoutTrailingZeros}</s>${selected_subscription_plan.discountedWithoutTrailingZeros}`;
      }
    });
  });

  // Variant change
  const variantInput = currentModal.querySelector('input[name="id"]');
  if (variantInput) {
    variantInput.addEventListener('change', function (evt) {
      let currentVariant = evt.target.value;
      let selected_variant_data = subscriptionJson.formattedVariantPrices.filter((el) => el.hasOwnProperty(currentVariant))[0][currentVariant];
      let currentSubscriptionPlan = Object.keys(selected_variant_data.formattedSellingPlanPrices[0])[0];
      let selected_subscription_plan = selected_variant_data.formattedSellingPlanPrices.filter((sub) => sub.hasOwnProperty(currentSubscriptionPlan))[0][currentSubscriptionPlan];

      if (productForm.querySelectorAll('input[name="selling_plan"]').length == 0) {
        var selling_plan_input1 = document.createElement("input");
        selling_plan_input1.setAttribute('type', 'hidden');
        selling_plan_input1.setAttribute('name', 'selling_plan');
        selling_plan_input1.value = currentModal.querySelector('input[name="purchaseOption"]:checked').value == 'subscription' ? currentSubscriptionPlan : null;
        productForm.appendChild(selling_plan_input1);
      } else {
        productForm.querySelector('input[name="selling_plan"]').value = currentModal.querySelector('input[name="purchaseOption"]:checked').value == 'subscription' ? currentSubscriptionPlan : null;
      }

      if (productForm.querySelector('input[name="selling_plan"]') != null && productForm.querySelector('input[name="selling_plan"]').value == '') {
        productForm.querySelector("#addToCartPrice").innerHTML = `${selected_variant_data.priceWithoutTrailingZeros}`;
      } else {
        productForm.querySelector("#addToCartPrice").innerHTML = `<s>${selected_variant_data.priceWithoutTrailingZeros}</s>${selected_subscription_plan.discountedWithoutTrailingZeros}`;
      }

      const subscriptionOption = currentModal.querySelector('.purchase-option__subscription');
      const oneTimeOption = currentModal.querySelector('.purchase-option__onetime');
      if (subscriptionOption) {
        subscriptionOption.querySelector('.price').innerHTML = selected_subscription_plan.discounted; 
        subscriptionOption.querySelector('.purchase-option__badge').innerHTML = `Save ${selected_subscription_plan.savings}`; 
      }
      if (oneTimeOption) {
        oneTimeOption.querySelector('.price').innerHTML = selected_variant_data.price; 
      }
    });
  }

  const settings = window.theme.settings;
  if (settings.defaultOtpPurchase) {
    const currentProduct = currentModal.dataset.productId;
    const allProducts = theme.cartSettings.products;
    let isRoutine = allProducts[currentProduct].isRoutine;

    if (!isRoutine) {
      currentModal.querySelector('input[name="purchaseOption"][value="onetime"]').click();
    }
  }
}
/** End quick add */

// Close menu items on Drawer close - Mobile Menu
document.addEventListener("theme:sliderule:close", function (event) {
  document.querySelectorAll('button.sliderow.is-active').forEach((el) => {
    el.click();
  });
});

// Recharge Widget Price and Button Text Update on PDP
if (window.theme.currentPage.includes("product")) {
  let currentProduct = window.theme.currentProduct;
  let subscribeMessage = 'Subscribe';
  var firstRun = true;
  
  function initRechargeWidgetCode(eventType) {
    let currentProduct = window.theme.currentProduct;
    var productFetchedInterval = setInterval(productFetched, 50);
    function productFetched() {
      const currentPage = window.theme.currentPage;
      const v2Widget = document.querySelector('recharge-subscription-widget');

      // Recharge widget v2
      if (v2Widget) {
        const widgetShadow = v2Widget?.shadowRoot;
        // Update the radio button styling in Recharge widget
        const radioBtn = widgetShadow.querySelectorAll('rc-radio-icon');
        if (radioBtn.length > 0) {
          radioBtn.forEach(radio => {
            radio.style.width= '18px';
            radio.style.height = '18px';
            const radioShadow = radio.shadowRoot;
            const innerRect = radio.shadowRoot.querySelectorAll('svg rect')[1];
            innerRect.style.fill = 'white';
            innerRect.style.stroke = 'white';

            const innerCircle = radio.shadowRoot.querySelector('svg circle');
            if (innerCircle) {
              innerCircle.setAttribute('r', innerCircle.getAttribute('cx') - 1);
            }
          })
        }

        // Remove learn more modal from the footer for recharge widget
        const modal = document.querySelector('rc-learn-more-modal');
        if (modal) {
          modal.shadowRoot.querySelector('footer').style.display = 'none';
        }

        if (currentPage === 'product.routines-alt' || currentPage === 'product.routines-new-pdp') {
          const title = document.createElement('h6');
          const titleNode = document.createTextNode(currentPage === 'product.routines-alt' ? 'SELECT PLAN' : '2. SELECT PLAN');
          title.appendChild(titleNode);
          if (!document.querySelector('.recharge-subscription-widget h6')) {
            title.classList.add('pdp-step-title');
            document.querySelector('.recharge-subscription-widget').prepend(title);
          }
        }

        if (v2Widget && v2Widget.product != undefined) {
          let textField = document.querySelector(".subscription-interval");
          if(textField) {
          textField.innerHTML = '';
        }

        /*** Start adding member benefits below Subscribe option */
        const label = widgetShadow.querySelector('.rc-purchase-option__subscription');

        if (label && !widgetShadow.querySelector('.membership-links')) {
          const container = document.createElement('div');
          container.className = 'membership-links';

          container.innerHTML = `
            <span>Save on every order</span>
            <span>|</span>
            <span>Skip or cancel anytime</span>
            <span>|</span>
            <a href="#" class="membership-modal-trigger" style="color:black;">More benefits</a>
          `;

          label.style.marginBottom = '0 !important';
          container.style.display = 'flex';
          container.style.gap = '6px';
          container.style.alignItems = 'center';
          container.style.fontSize = '12px';
          container.style.marginTop = '0';
          container.style.marginBottom = '1rem';
          container.style.justifyContent = 'center';
          container.style.fontWeight = '500';
          container.style.textWrap = 'nowrap';

          label.insertAdjacentElement('afterend', container);

          container
            .querySelector('.membership-modal-trigger')
            .addEventListener('click', (e) => {
              e.preventDefault();
              document.querySelector('#membership-benefits-modal-popup')?.forceOpenProductModal();
            });
        }

          /* Start setting savings in Subscribe option */
          var subSavings = Number(window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].unit.replace(/[^\d.]/g, "")) - Number(window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].discounted.replace(/[^\d.]/g, ""))
          const selector = widgetShadow.querySelector('[part="rc-purchase-option__selector rc-purchase-option__selector_subscription"]');
          const textNode = [...selector.childNodes].find(
            node => node.nodeType === Node.TEXT_NODE && node.textContent.includes('Subscribe')
          );

          if (textNode) {
            // Insert after the text node
            if (!selector.querySelector('.savings')) {
              const span = document.createElement('span');
              span.textContent = `Save ${formatMoneyHelper(subSavings * 100, window.theme.shopMoneyWithCurrencyFormat).replace(' USD', '')}`;

              span.style.fontWeight = '500';
              span.style.borderRadius = '600px';
              span.style.fontSize = '12px';
              span.style.padding = '0.3rem 0.8rem';
              span.style.background = '#0F866A';
              span.style.color = 'white';
              span.style.marginLeft = '0.3rem';
              span.style.textAlign = 'center';
              span.className = 'savings';

              textNode.parentNode.insertBefore(span, textNode.nextSibling);
            } else {
              selector.querySelector('.savings').textContent = `Save ${formatMoneyHelper(subSavings * 100, window.theme.shopMoneyWithCurrencyFormat).replace(' USD', '')}`;
            }
          }
          /* Start setting savings in Subscribe option */

          /** Start setting shipping information in purchase options */
          if (currentPage === 'product.routines' || currentPage === 'product.acne-routines') {
            const subscriptionPurchaseOptionPrice = widgetShadow.querySelector('[part="rc-purchase-option__discounted-price"]');
            if (!subscriptionPurchaseOptionPrice.querySelector('.shipping')) {
              const span = document.createElement('span');
              span.className = 'shipping';
              span.textContent = `+ FREE Shipping`;
              span.style.color = '#0f866a';
              span.style.textAlign = 'right';
              subscriptionPurchaseOptionPrice.appendChild(span);
            }

            const otpPurchaseOption = widgetShadow.querySelector('[part="rc-purchase-option rc-purchase-option__onetime"]');
            if (otpPurchaseOption) {
              const otpPurchaseOptionPrice = otpPurchaseOption.querySelector('.rc-purchase-option__prices');
              if (!otpPurchaseOptionPrice.querySelector('.shipping')) {
                const span = document.createElement('span');
                span.className = 'shipping';
                span.textContent = `+ shipping`;
                span.style.color = '#808080';
                span.style.fontWeight = 'normal';
                otpPurchaseOptionPrice.appendChild(span);
              }
            }
          }

          

          // Start Logic for AM large
          const amLargeVariants = [41427726368947,42591972130995,44326888243379];
          const isAmLargeProduct = amLargeVariants.includes(Number(v2Widget.variantId))
          let discountOTP = 0;
          if (isAmLargeProduct) {
            discountOTP = 0.5;
          }
          if (isAmLargeProduct) {
            let unitPrice = window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].unit;
            const match = unitPrice.match(/\d+(?:[.,]\d+)?/);
            const amount = match ? parseFloat(match[0].replace(',', '.')) : 0;
            const additionalDiscount = discountOTP;
            const discountedOTPprice = amount * additionalDiscount;
            const formattedDiscountedOTPPrice = formatMoneyHelper(discountedOTPprice * 100, window.theme.shopMoneyWithCurrencyFormat);  
            widgetShadow.querySelector('.rc-selection__onetime .rc-price').innerHTML =  `<s>${unitPrice}</s> ${formattedDiscountedOTPPrice.replace(' USD', '')}`
          } else {
            let unitPrice = window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].unit;
            widgetShadow.querySelector('.rc-selection__onetime .rc-price').innerHTML =  unitPrice;
          }
          // End Logic for AM large

          if (v2Widget.sellingPlanId !== undefined && v2Widget.sellingPlanId !== null) {
            let unitPrice = window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].unit;
            if (v2Widget.prices.discounted === "") {
              var discountedPrice = window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].unit;
            } else {
              var discountedPrice = window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].discounted;
            }
            let newData = v2Widget.variantPlans.filter(
              (plan) => v2Widget.sellingPlanId && v2Widget.sellingPlanId === plan.external_plan_id
            );
            if (newData.length) {
              var intervalID = setInterval(updateLabel, 50);
              function updateLabel() {
                var widgetSubscriptionElement = widgetShadow.querySelector('[part="rc-purchase-option__selector rc-purchase-option__selector_subscription"]')
                if (widgetSubscriptionElement.textContent !== null) {
                  if (v2Widget.sellingPlanId) {
                    const discount = v2Widget.variantPlans[0].discount_amount;
                    widgetSubscriptionElement.textContent.replace(subscribeMessage, `${subscribeMessage} (${parseFloat(discount).toFixed(0)}% Off)`);
                  }
                  clearInterval(intervalID);
                  intervalID = null;
                  const urlParams = new URLSearchParams(window.location.search);
                  const allProducts = theme.cartSettings.products;
                  let isRoutine = allProducts[currentProduct] != null ? allProducts[currentProduct].isRoutine : false;
                  const defaultOtpPurchase = window.theme.settings.defaultOtpPurchase || false;
                  if (defaultOtpPurchase) {
                    if ((urlParams.get('type') != null && urlParams.get('type') == 'otp' && eventType == 'sellingplan' && firstRun) || (!isRoutine && firstRun)) {
                      firstRun = false;
                      widgetShadow.querySelector('input[name="purchaseOption"][value="onetime"]').click();
                    }
                  } else {
                    if ((urlParams.get('type') != null && urlParams.get('type') == 'otp' && eventType == 'sellingplan' && firstRun)) {
                      firstRun = false;
                      widgetShadow.querySelector('input[name="purchaseOption"][value="onetime"]').click();
                    }
                  }
                }
              }
              document.getElementById('addToCartPrice').innerHTML = `<s aria-label="One-time price">${unitPrice.replace('.00', '')}</s> ${discountedPrice.replace('.00', '')}`
            }
          }
          if (v2Widget.sellingPlanId === undefined || v2Widget.sellingPlanId === null) {
            if (textField !== null) {
              textField.innerHTML = '';
            }
            // Init change AM Large in CTA
            //let unitPrice = window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].unit;
            let unitPrice = window.SubscriptionWidgetConfig.formattedPrices[v2Widget.variantId].unit;
            const amLargeVariants = [41427726368947,42591972130995,44326888243379];
            if (amLargeVariants.includes(Number(v2Widget.variantId))) {
              const match = unitPrice.match(/\d+(?:[.,]\d+)?/);
              const amount = match ? parseFloat(match[0].replace(',', '.')) : 0;
              const additionalDiscount = 0.5; 
              const discountedOTPprice = amount * additionalDiscount;
              const formattedDiscountedOTPPrice = formatMoneyHelper(discountedOTPprice * 100,window.theme.shopMoneyWithCurrencyFormat);
              document.getElementById('addToCartPrice').innerHTML = `<s>${unitPrice.replace('.00', '')}</s>${formattedDiscountedOTPPrice.replace(' USD', '')}`;
            } else {
              document.getElementById('addToCartPrice').innerHTML = `${unitPrice.replace('.00', '')}`;
            }
            //End change AM Large in CTA
          }
          clearInterval(productFetchedInterval);
          productFetchedInterval = null;
        }
      }
      if(window.RechargePubSub) {
        window.RechargePubSub.subscribe('cart:item:update', function (data) {
          document.dispatchEvent(
            new CustomEvent('theme:cart-overlay:close', {
              bubbles: true,
            })
          );
          document.dispatchEvent(
            new CustomEvent('theme:cart-drawer:reload', {
              bubbles: true,
            })
          );
        });
      }
    }
  }

    function formatMoneyHelper(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholderRegex);

    const formatType = match ? match[1] : 'amount';

    function formatNumber(number, decimals = 2, thousands = ',', decimal = '.') {
      const n = (number / 100).toFixed(decimals)
      const parts = n.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }

    let value;
    switch (formatType) {
      case 'amount':
        value = formatNumber(cents, 2, ',', '.');
        break;

      case 'amount_no_decimals':
        value = formatNumber(cents, 2, ',', '.');
        //value = value.replace('.00', '')
        break;

      case 'amount_with_comma_separator':
        value = formatNumber(cents, 2, '.', ',');
        break;

      case 'amount_with_space_separator':
        value = formatNumber(cents, 2, ' ', ',');
        break;

      case 'amount_with_apostrophe_separator':
        value = formatNumber(cents, 2, "'", '.');
        break;

      default:
        value = formatNumber(cents, 2, ',', '.');
    }

    return format.replace(placeholderRegex, value);
  }


  // Initial State
   if (window.Recharge && window.Recharge.eventService) {
      window.Recharge.eventService.addEventListener(
      `product:${currentProduct}:fetched`,
      function (event) {
        initRechargeWidgetCode('fetched');
      }
    );

    // When Selling plan updated
    window.Recharge.eventService.addEventListener(
      `${currentProduct}:sellingPlan:change`,
      function (event) {
        initRechargeWidgetCode('sellingplan');
      }
    );
    
    // Variant Updated
    window.Recharge.eventService.addEventListener(
      `${currentProduct}:variant:change`,
      function (event) {
        initRechargeWidgetCode('variant');
      }
    );
  }
}


/*Level Guide*/
// document.addEventListener("click", function (event) {
//   // console.log("Level Guide")
//   if (event.target && event.target.id === "levelGuideBtn") {
//     // console.log('Clicked');
//     const levelGuidePopUp = document.getElementById("level-guide-pop-up");
//     if (levelGuidePopUp) {
//       levelGuidePopUp.click();
//     } else {
//       console.log("levelGuidePopUp not found");
//     }
//   }
// });

/*Link Tabs*/
document.addEventListener("DOMContentLoaded", function () {
  let linkElements = document.getElementsByClassName("link-tabs__tab");

  for (let i = 0; i < linkElements.length; i++) {
    linkElements[i].addEventListener("click", function () {
      // Remove the class from all elements
      for (let j = 0; j < linkElements.length; j++) {
        if (linkElements[j] !== this) {
          linkElements[j].classList.remove("link-tab__active__underline");
        }
      }

      // Toggle the class for the clicked element
      this.classList.toggle("link-tab__active__underline");
    });
  }
});

//  https://tiege-hanley-store.myshopify.com/ -- Cart Logics

async function addItemtoCart(variantId) {
  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };
  await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function addSubsItemtoCart(variantId, sellingPlanId) {
  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId
      },
    ],
  };
  await fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function changeItemQty(lineItem, qty) {
  var formData = new FormData();
  formData.append(`updates[${lineItem}]`, qty);
  await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function changeItemQtywithReload(lineItem, qty) {
  var formData = new FormData();
  formData.append(`updates[${lineItem}]`, qty);
  await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      var eventReload = new Event("theme:cart-drawer:reload", {
        bubbles: true,
        cancelable: false,
      });
      document.dispatchEvent(eventReload);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function removeMultiple(lineItems) {
  var formData = new FormData();
  lineItems.forEach((el) => {
    formData.append(`updates[${el}]`, 0);
  });
  await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {})
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function removeMultiplewithReload(lineItems) {
  var formData = new FormData();
  lineItems.forEach((el) => {
    formData.append(`updates[${el}]`, 0);
  });
  await fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    body: formData,
  })
    .then((response) => response.json())
    .then((data) => {
      var eventReload = new Event("theme:cart-drawer:reload", {
        bubbles: true,
        cancelable: false,
      });
      document.dispatchEvent(eventReload);
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

async function showMessageDuplicateRoutine(lineItem) {
  let cartItems = document.querySelector(".cart-alert");
  cartItems.innerHTML = "";
  cartItems.innerHTML = `<div class="alert-confirm">
    <p class="cart__item__title cart__item__alert-custom">${window.theme.cartSettings.singleRoutine.alert}</p>
    <div class="buttons-holder">
      <button type="button" data-replace-alert data-remove-product=${lineItem} class="btn btn--primary btn--solid">Replace</button>
      <button type="button" data-dismiss-alert class="btn btn--primary btn--outline">Keep Both</button>
    </div>
  </div>`;
  let replaceButton = cartItems.querySelector("[data-replace-alert]");
  let closeButton = cartItems.querySelector("[data-dismiss-alert]");
  replaceButton.addEventListener("click", (e) => {
    changeItemQtywithReload(replaceButton.dataset.removeProduct, "0");
    cartItems.innerHTML = "";
  });
  closeButton.addEventListener("click", (e) => {
    cartItems.innerHTML = "";
  });
}

async function showMessageDuplicateProducts(lineItems, isRoutine) {
  let cartItems = document.querySelector(".cart-alert");
  cartItems.innerHTML = "";
  if (isRoutine) {
    var message = window.theme.cartSettings.duplication.alert_routine;
  } else {
    var message = window.theme.cartSettings.duplication.alert_product;
  }
  var buttonOne = "Remove";
  var buttonTwo = "Keep";
  cartItems.innerHTML = `<div class="alert-confirm">
    <p class="cart__item__title cart__item__alert-custom">${message}</p>
    <div class="buttons-holder">
      <button type="button" data-remove-alert data-remove-products class="btn btn--primary btn--solid">${buttonOne}</button>
      <button type="button" data-dismiss-alert class="btn btn--primary btn--outline">${buttonTwo}</button>
    </div>
  </div>`;
  let replaceButton = cartItems.querySelector("[data-remove-alert]");
  let closeButton = cartItems.querySelector("[data-dismiss-alert]");
  replaceButton.addEventListener("click", (e) => {
    removeMultiplewithReload(lineItems);
    cartItems.innerHTML = "";
  });
  closeButton.addEventListener("click", (e) => {
    cartItems.innerHTML = "";
  });
}

async function addedCartFunction(addedItem, data) {
  let alertStatus = "",
    alertMessage = "",
    reloadCart = false;
  const allProducts = theme.cartSettings.products;
  let isCurrentAddedItemRoutine = allProducts[addedItem.product_id].isRoutine;
  // Free Item Addition
  if (theme.cartSettings.giftItem.enabled) {
    let giftExists = data.items.filter(
      (item) => item.product_id == theme.cartSettings.giftItem.productId
    );
    if (giftExists.length > 0) {
      let giftQty = giftExists[0]["quantity"];

      if (giftQty > 1) {
        reloadCart = true;
        await changeItemQty(giftExists[0].key, "1");
      }
    }

    if (theme.cartSettings.giftItem.method == "cart") {
      let minCartValue = parseInt(theme.cartSettings.giftItem.cartValue * 100 * Shopify.currency.rate);
      const purchaseOption = theme.cartSettings.giftItem.purchaseOption;
      let cartValue = 0;
      if (purchaseOption == 'both') {
        const itemsToConsider = data.items.filter(l => l.id != theme.cartSettings.giftItem.variantId)
        cartValue = itemsToConsider.reduce((acc, current) => {
          const amount = parseFloat(current.final_line_price);
          return acc + amount;
        }, 0);
      } else {
        const itemsToConsider = purchaseOption == 'subscription' ? data.items.filter(l => l.selling_plan_allocation && l.id != theme.cartSettings.giftItem.variantId) : data.items.filter(l => !l.selling_plan_allocation && l.id != theme.cartSettings.giftItem.variantId);
        cartValue = itemsToConsider.reduce((acc, current) => {
          const amount = parseFloat(current.final_line_price);
          return acc + amount;
        }, 0);
      }

      if (cartValue > minCartValue) {
        if (giftExists.length === 0) {
          reloadCart = true;
          alertStatus = "success";
          alertMessage = window.theme.cartSettings.giftItem.success_alert;
          await addItemtoCart(theme.cartSettings.giftItem.variantId);
        }
      } else {
        if (giftExists.length > 0) {
          reloadCart = true;
          alertStatus = "error";
          alertMessage = window.theme.cartSettings.giftItem.error_alert;
          await changeItemQty(giftExists[0].key, "0");
        }
      }
    } else {
      let eligibleProducts = theme.cartSettings.giftItem.collection
        .split(",")
        .map(Number);
      if (eligibleProducts.includes(addedItem.product_id)) {
        if (giftExists.length === 0) {
          reloadCart = true;
          alertStatus = "success";
          alertMessage = window.theme.cartSettings.giftItem.success_alert;
          await addItemtoCart(theme.cartSettings.giftItem.variantId);
        }
      } else {
        let eligibleItemsinCart = data.items.filter((item) =>
          eligibleProducts.includes(item.product_id)
        );
        if (eligibleItemsinCart.length === 0 && giftExists.length > 0) {
          reloadCart = true;
          alertStatus = "error";
          alertMessage = window.theme.cartSettings.giftItem.error_alert;
          await changeItemQty(giftExists[0].key, "0");
        }
      }
    }
  }

  // Single Routine Checks
  if (theme.cartSettings.singleRoutine.enabled && isCurrentAddedItemRoutine) {
    let routineItem = null;
    data.items.forEach((element) => {
      if (
        allProducts[element.product_id].isRoutine &&
        element.product_id != addedItem.product_id
      ) {
        routineItem = element;
      }
    });
    if (routineItem != null) {
      if (window.theme.cartSettings.singleRoutine.show_alert) {
        await showMessageDuplicateRoutine(routineItem.key);
        return;
      }
    }
  }

  // Upgradability Check
  if (theme.cartSettings.upgradability.enabled) {
    let routineItem = null;
    data.items.forEach((element) => {
      if (allProducts[element.product_id].isRoutine) {
        routineItem = element;
      }
    });
    if (routineItem != null) {
      let otherItems = data.items.filter(
        (item) => item.product_id != routineItem.product_id
      );
      
      let otherItemIds = otherItems.map((item) => item.variant_id);
      let upgradeItem =
        allProducts[routineItem.product_id].nextRoutineLineItem != false
          ? allProducts[routineItem.product_id].nextRoutineLineItem.id
          : false;
      let upgradeSystem =
        allProducts[routineItem.product_id].nextRoutine != false
          ? allProducts[routineItem.product_id].nextRoutine.variantId
          : false;

      let subsPlan = allProducts[routineItem.product_id].nextRoutine != false
          ? allProducts[routineItem.product_id].nextRoutine.sellingPlan
          : false;
      if (upgradeSystem != false && otherItemIds.includes(upgradeItem)) {
        var cartUpdated = false;

        let itemRemove = data.items.filter(
          (item) => item.variant_id == upgradeItem
        )[0].key;
        
        let upgradeItemData = otherItems.filter((item) => item.variant_id == upgradeItem);

        if (routineItem.quantity == upgradeItemData[0].quantity) {
          if (routineItem.hasOwnProperty('selling_plan_allocation') && upgradeItemData[0].hasOwnProperty('selling_plan_allocation')) {
            if (subsPlan != false) {
              await removeMultiple([itemRemove, routineItem.key]);
              await addSubsItemtoCart(upgradeSystem, subsPlan);
              cartUpdated = true;
            }
          } else if (!routineItem.hasOwnProperty('selling_plan_allocation') && !upgradeItemData[0].hasOwnProperty('selling_plan_allocation')) {
            await removeMultiple([itemRemove, routineItem.key]);
            await addItemtoCart(upgradeSystem);
            cartUpdated = true;
          }
        }

        if (cartUpdated) {
          reloadCart = true;
          alertStatus = "success";
          alertMessage = window.theme.cartSettings.upgradability.alert;
          
          var eventReload = new Event("theme:cart-drawer:reload", {
            bubbles: true,
            cancelable: false,
          });
          document.dispatchEvent(eventReload);
          const eventAlert = new CustomEvent("theme:cart-drawer:alert", {
            detail: { status: alertStatus, message: alertMessage },
          });
          document.dispatchEvent(eventAlert);
          return;
        }
      }
    }
  }

  // Duplication Check
  if (theme.cartSettings.duplication.enabled) {
    let routineItem = null;
    data.items.forEach((element) => {
      if (allProducts[element.product_id].isRoutine) {
        routineItem = element;
      }
    });
    if (routineItem != null) {
      let otherItems = data.items.filter(
        (item) => item.product_id != routineItem.product_id
      );
      let otherItemIds = otherItems.map((item) => item.variant_id);
      let variantsOfRoutine = allProducts[routineItem.product_id][
        "routineVariants"
      ].map((item) => item.id);
      let haveCommonItems = otherItemIds.filter((item) =>
        variantsOfRoutine.includes(item)
      );
      let commonItemsKeys = data.items
        .filter((item) => haveCommonItems.includes(item.variant_id))
        .map((item) => item.key);
      if (commonItemsKeys.length > 0) {
        // await removeMultiple(commonItemsKeys);
        await showMessageDuplicateProducts(
          commonItemsKeys,
          isCurrentAddedItemRoutine
        );
        return;
      }
    }
  }

  if (reloadCart) {
    var eventReload = new Event("theme:cart-drawer:reload", {
      bubbles: true,
      cancelable: false,
    });
    document.dispatchEvent(eventReload);
  }

  if (alertStatus != null && alertMessage != null) {
    const eventAlert = new CustomEvent("theme:cart-drawer:alert", {
      detail: { status: alertStatus, message: alertMessage },
    });
    document.dispatchEvent(eventAlert);
  }
}

async function updatedCartFunction(data) {
  let alertStatus = "",
    alertMessage = "",
    reloadCart = false;

  const allProducts = theme.cartSettings.products;

  if (theme.cartSettings.giftItem.enabled) {
    let giftExists = data.items.filter(
      (item) => item.product_id == theme.cartSettings.giftItem.productId
    );
    if (giftExists.length > 0) {
      let giftQty = giftExists[0]["quantity"];

      if (giftQty > 1) {
        reloadCart = true;
        await changeItemQty(giftExists[0].key, "1");
      }
    }

    if (theme.cartSettings.giftItem.method == "cart") {
      let minCartValue = parseInt(theme.cartSettings.giftItem.cartValue * 100 * Shopify.currency.rate);
      const purchaseOption = theme.cartSettings.giftItem.purchaseOption;
      let cartValue = 0;
      if (purchaseOption == 'both') {
        const itemsToConsider = data.items.filter(l => l.id != theme.cartSettings.giftItem.variantId)
        cartValue = itemsToConsider.reduce((acc, current) => {
          const amount = parseFloat(current.final_line_price);
          return acc + amount;
        }, 0);
      } else {
        const itemsToConsider = purchaseOption == 'subscription' ? data.items.filter(l => l.selling_plan_allocation && l.id != theme.cartSettings.giftItem.variantId) : data.items.filter(l => !l.selling_plan_allocation && l.id != theme.cartSettings.giftItem.variantId);
        cartValue = itemsToConsider.reduce((acc, current) => {
          const amount = parseFloat(current.final_line_price);
          return acc + amount;
        }, 0);
      }

      if (cartValue > minCartValue) {
        if (giftExists.length === 0) {
          reloadCart = true;
          alertStatus = "success";
          alertMessage = window.theme.cartSettings.giftItem.success_alert;
          await addItemtoCart(theme.cartSettings.giftItem.variantId);
        }
      } else {
        if (giftExists.length > 0) {
          reloadCart = true;
          alertStatus = "error";
          alertMessage = window.theme.cartSettings.giftItem.error_alert;
          await changeItemQty(giftExists[0].key, "0");
        }
      }
    } else {
      let eligibleProducts = theme.cartSettings.giftItem.collection
        .split(",")
        .map(Number);
      let eligibleItemsinCart = data.items.filter((item) =>
        eligibleProducts.includes(item.product_id)
      );
      if (eligibleItemsinCart.length > 0) {
        if (giftExists.length === 0) {
          reloadCart = true;
          alertStatus = "success";
          alertMessage = window.theme.cartSettings.giftItem.success_alert;
          await addItemtoCart(theme.cartSettings.giftItem.variantId);
        }
      } else {
        if (giftExists.length > 0) {
          reloadCart = true;
          alertStatus = "error";
          alertMessage = window.theme.cartSettings.giftItem.error_alert;
          await changeItemQty(giftExists[0].key, "0");
        }
      }
    }
  }

  if (reloadCart) {
    var eventReload = new Event("theme:cart-drawer:reload", {
      bubbles: true,
      cancelable: false,
    });
    document.dispatchEvent(eventReload);
  }

  if (alertStatus != "" && alertMessage != "") {
    const eventAlert = new CustomEvent("theme:cart-drawer:alert", {
      detail: { status: alertStatus, message: alertMessage },
    });
    document.dispatchEvent(eventAlert);
  }
}

// Cart add logic triggeres addedCartFunction
document.addEventListener("theme:product:add", function (e) {
  let addedItem = e.detail.response;
  fetch(window.theme.routes.cart_url + ".json")
    .then((response) => response.json())
    .then((data) => {
      addedCartFunction(addedItem, data);
    });
});

// Cart update logic triggers updateCartFunction
document.addEventListener("theme:cart:change", function (e) {
  fetch(window.theme.routes.cart_url + ".json")
    .then((response) => response.json())
    .then((data) => {
      updatedCartFunction(data);
    });
});

// Change position of AccessiBee and ZenDesk on PDP
/*if (window.theme.currentPage.includes("product")) {
  function getWindowWidth() {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  }
  
  if (getWindowWidth() < window.theme.sizes.small) {
    var mobileOffset = 40;
  } else {
    var mobileOffset = 0;
  }
  */

  //Cart bar in PDP
  /*$(window).scroll(function (event) {
    if ($('#cart-bar').hasClass('is-visible')) {
      $('div:has(iframe[title="Close message"])').css('bottom', `${mobileOffset + 168 }px`);
      $('iframe[title="Messaging window"]').css('inset', `auto 16px ${mobileOffset + 168 }px auto`);
      $("iframe#launcher").css('bottom', `${mobileOffset + 96}px`);
      $('iframe[title="Number of unread messages"]').css('bottom', `${mobileOffset + 144}px`);
      document.querySelectorAll('access-widget-ui').forEach((el) => {
        el.style.setProperty("--offset-top", `${mobileOffset + 100}px`);
      });
    } else {
      $('div:has(iframe[title="Close message"])').css('bottom', '88px');
      $('iframe[title="Messaging window"]').css('inset', `auto 16px 88px auto`);
      $("iframe#launcher").css('bottom', '16px');
      $('iframe[title="Number of unread messages"]').css('bottom', '64px');
      document.querySelectorAll('access-widget-ui').forEach((el) => {
        el.style.setProperty("--offset-top", "20px");
      });
    }
  });
}*/

// Contact Form Submission Code
// Contact Form Submission Code
function validateContactFormInputs (form) {
  let missingFields = [];
  let alert_message = form.querySelector('.form-success');

  if (!form.querySelector("input[name='contact[name]']").value.trim()) {
    missingFields.push('Missing name');
  }
  if (!form.querySelector("input[name='contact[telephone]']").value.trim()) {
    missingFields.push('Missing phone number');
  }
  if (!form.querySelector("input[name='contact[email]']").value.trim()) {
    missingFields.push('Missing email');
  }
  if (!form.querySelector("select[name='contact[topic]']").value.trim()) {
    missingFields.push('Missing topic');
  }
    if (!form.querySelector("input[name='contact[subject]']").value.trim()) {
    missingFields.push('Missing subject')
  }
    if (!form.querySelector("textarea[name='contact[body]']").value.trim()) {
    missingFields.push('Missing message')
  }

  alert_message.classList.remove('hidden');
  alert_message.classList.add('error');
  alert_message.innerHTML = `<ul>${missingFields.map(item => `<li>${item}</li>`).join("")}</ul>`;
  return missingFields.length > 0 ? false : true
}

const contact_form = document.querySelector("form#contact-us-page");
if (contact_form) {
  contact_form.addEventListener("submit", (evt) => {
      evt.stopImmediatePropagation();
      evt.preventDefault();
      let alert_message = contact_form.querySelector('.form-success');
      let submit_button = contact_form.querySelector('button[type="submit"]');
      let form_Data = {
        name: contact_form.querySelector("input[name='contact[name]']").value,
        phone: contact_form.querySelector("input[name='contact[telephone]']").value,
        email: contact_form.querySelector("input[name='contact[email]']").value,
        topic: contact_form.querySelector("select[name='contact[topic]']").value,
        subject: contact_form.querySelector("input[name='contact[subject]']").value,
        comment: contact_form.querySelector("textarea[name='contact[body]']").value
      }
    
      const zendesk_url = contact_form.querySelector('input[name="zendesk"]');
      if (zendesk_url == null) {
        return;
      }

      if (!alert_message.classList.contains('hidden')) {
        alert_message.classList.add('hidden');
        alert_message.classList.remove('error');
        alert_message.innerHTML = '';
      }
      submit_button.setAttribute("disabled", "disabled");
      submit_button.classList.add('is-loading');
      submit_button.querySelector(".btn__text").style.display = "none";

      if (validateContactFormInputs(contact_form)){
        fetch(zendesk_url.dataset.url, {
          method : "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(form_Data)
        }).then(response => {
            if (response.ok) {
              contact_form.reset();
              alert_message.classList.remove('hidden');
              alert_message.innerHTML = "Thanks for contacting us. We'll get back to you as soon as possible.";
            }
            return response.json(); 
          }).then((response)=> {
            let errorMsg =  "Unable to process your request. Please try again later.";
            if (response.error && response.error.description == 'Record validation errors') {
              response.error.details.requester.map(item => item.description);
              const errors= response.error.details.requester.map(item =>`<li>${item.description.toLowerCase().replace('requester:', 'Invalid')}</li`)
              errorMsg = `<ul>${errors.join("")}</ul>`;
            }
            alert_message.classList.remove('hidden');
            alert_message.classList.add('error');
            alert_message.innerHTML = errorMsg;
            setTimeout(() => {
              submit_button.classList.remove('is-loading');
              submit_button.querySelector(".btn__text").style.display = "block";
            }, 500);
            submit_button.removeAttribute("disabled");
        }).catch(function(error) {
          console.log(error);
        });
      } else {
        submit_button.classList.remove('is-loading');
        submit_button.querySelector(".btn__text").style.display = "block";
        submit_button.removeAttribute("disabled");
      }
  });
}

// Press Enquiry Form Submission Code
const press_form = document.querySelector("form#press-enquiry-page");
if (press_form) {
  const relationship_selector = press_form.querySelector('select[name="inquiry[reason-for-contact]"]');
  relationship_selector.addEventListener('change', (evt) => {
    let currentValue = evt.target.value;
    let selectedValueText = evt.target.options[evt.target.selectedIndex].text;
    press_form.querySelector('.custom-form h2').innerHTML = `${currentValue} Inquiry`;
    if (selectedValueText == 'Press') {
      if (press_form.querySelector('[data-group="press"]').classList.contains('hidden')) {
        press_form.querySelector('[data-group="press"]').classList.remove('hidden');
      }
      if (!press_form.querySelector('[data-group="influencer"]').classList.contains('hidden')) {
        press_form.querySelector('[data-group="influencer"]').classList.add('hidden');
      }
      press_form.querySelector("select[name='inquiry[type-of-coverage]']").setAttribute("required", "required");
      press_form.querySelector("select[name='inquiry[nature-of-relationship]']").removeAttribute("required");
    } else if (selectedValueText == 'Influencer') {
      if (!press_form.querySelector('[data-group="press"]').classList.contains('hidden')) {
        press_form.querySelector('[data-group="press"]').classList.add('hidden');
      }
      if (press_form.querySelector('[data-group="influencer"]').classList.contains('hidden')) {
        press_form.querySelector('[data-group="influencer"]').classList.remove('hidden');
      }
      press_form.querySelector("select[name='inquiry[nature-of-relationship]']").setAttribute("required", "required");
      press_form.querySelector("select[name='inquiry[type-of-coverage]']").removeAttribute("required");
    } else {
      if (!press_form.querySelector('[data-group="press"]').classList.contains('hidden')) {
        press_form.querySelector('[data-group="press"]').classList.add('hidden');
      }
      if (!press_form.querySelector('[data-group="influencer"]').classList.contains('hidden')) {
        press_form.querySelector('[data-group="influencer"]').classList.add('hidden');
      }
      press_form.querySelector("select[name='inquiry[nature-of-relationship]']").removeAttribute("required");
      press_form.querySelector("select[name='inquiry[type-of-coverage]']").removeAttribute("required");
    }

    press_form.addEventListener("submit", (evt) => {
      evt.stopImmediatePropagation();
      evt.preventDefault();
      let alert_message = press_form.querySelector('.form-success');
      let submit_button = press_form.querySelector('button[type="submit"]');
      let form_Data = {
        name: press_form.querySelector("input[name='inquiry[name]']").value, 
        phone: press_form.querySelector("input[name='inquiry[phone]']").value,
        email: press_form.querySelector("input[name='inquiry[email]']").value, 
        companyname: press_form.querySelector("input[name='inquiry[company-name]']").value,
        reasonforcontact: press_form.querySelector("select[name='inquiry[reason-for-contact]']").value.replace(' ', '_'),
        typeofcoverage: press_form.querySelector("select[name='inquiry[type-of-coverage]']").value || '-',
        websitelink: press_form.querySelector("input[name='inquiry[website-link]']").value,
        natureofrelationship: press_form.querySelector("select[name='inquiry[nature-of-relationship]']").value || '-',
        instagram: press_form.querySelector("input[name='inquiry[instagram]']").value,
        websiteblog: press_form.querySelector("input[name='inquiry[website]']").value,
        youtube: press_form.querySelector("input[name='inquiry[youtube]']").value,
        other: press_form.querySelector("input[name='inquiry[other]']").value,
        comment: press_form.querySelector("textarea[name='inquiry[body]']").value,
        subject: press_form.querySelector("input[name='inquiry[subject]']").value
      }

      const zendesk_url = press_form.querySelector('input[name="zendesk"]');
      if (zendesk_url == null) {
        return;
      }

      if (!alert_message.classList.contains('hidden')) {
        alert_message.classList.add('hidden');
        alert_message.classList.remove('error');
        alert_message.innerHTML = '';
      }
      submit_button.setAttribute("disabled", "disabled");
      submit_button.classList.add('is-loading');
      submit_button.querySelector(".btn__text").style.display = "none";
    
      fetch(zendesk_url.dataset.url, {
        method : "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form_Data)
      }).then((response) => {
        if (response.status == 200) {
          press_form.reset();
          alert_message.classList.remove('hidden');
          alert_message.innerHTML = "Thanks for contacting us. We'll get back to you as soon as possible.";
        } else {
          alert_message.classList.remove('hidden');
          alert_message.classList.add('error');
          alert_message.innerHTML = "Unable to process your request. Please try again later.";
        }
        setTimeout(() => {
          submit_button.classList.remove('is-loading');
          submit_button.querySelector(".btn__text").style.display = "block";
        }, 500);
        submit_button.removeAttribute("disabled");
      }).catch(function(error) {
        console.log(error);
      });
    });
  });
}

// Wholesale Enquiry Form Submission Code
const wholesale_form = document.querySelector("form#wholesale-page");
if (wholesale_form) {
  wholesale_form.querySelector('input[name="contact[other]"]').classList.add('hidden');
  wholesale_form.querySelector('input[name="contact[other]"]').labels[0].classList.add('hidden');
  const typeOfBusinessSelector = wholesale_form.querySelector('select[name="contact[type-of-business]"]');
  typeOfBusinessSelector.addEventListener('change', (evt) => {
    let currentValue = evt.target.value;
    let selectedValueText = evt.target.options[evt.target.selectedIndex].text;
    if (selectedValueText == 'Other') {
      if (wholesale_form.querySelector('input[name="contact[other]"]').classList.contains('hidden')) {
        wholesale_form.querySelector('input[name="contact[other]"]').classList.remove('hidden');
        wholesale_form.querySelector('input[name="contact[other]"]').labels[0].classList.remove('hidden');
      }
    } else {
      if (!wholesale_form.querySelector('input[name="contact[other]"]').classList.contains('hidden')) {
        wholesale_form.querySelector('input[name="contact[other]"]').classList.add('hidden');
        wholesale_form.querySelector('input[name="contact[other]"]').labels[0].classList.add('hidden');
      }
    }
  });

  wholesale_form.addEventListener("submit", (evt) => {
    evt.stopImmediatePropagation();
    evt.preventDefault();
    let alert_message = wholesale_form.querySelector('.form-success');
    let submit_button = wholesale_form.querySelector('button[type="submit"]');
    let typeOfBusinessSelectedIndex = wholesale_form.querySelector("select[name='contact[type-of-business]']").selectedIndex;
    let typeOfBusiness = wholesale_form.querySelector("select[name='contact[type-of-business]']").options[typeOfBusinessSelectedIndex].label;
    let form_Data = {
      business_name: wholesale_form.querySelector("input[name='contact[business-name]']").value, 
      business_dba: wholesale_form.querySelector("input[name='contact[dba-name-if-different]']").value || '-',
      business_type: (typeOfBusiness == 'Other' ? wholesale_form.querySelector("input[name='contact[other]']").value : typeOfBusiness) || '-',
      business_time: wholesale_form.querySelector("input[name='contact[length-of-time-in-business]']").value || '-',
      brands: wholesale_form.querySelector("textarea[name='contact[current-brands-sold]']").value || '-',
      location: wholesale_form.querySelector("input[name='contact[location]']").value || '-',
      location_phone: wholesale_form.querySelector("input[name='contact[location-phone-number]']").value || '-',
      location_qty: wholesale_form.querySelector("input[name='contact[number]']").value,
      contact_name: wholesale_form.querySelector("input[name='contact[name]']").value || '-',
      contact_position: wholesale_form.querySelector("input[name='contact[position]']").value || '-',
      contact_email: wholesale_form.querySelector("input[name='contact[email]']").value,
      message: wholesale_form.querySelector("textarea[name='contact[body]']").value,
      type: 'wholesale',
    }

    const zendesk_url = wholesale_form.querySelector('input[name="zendesk"]');
    if (zendesk_url == null) {
      return;
    }

    if (!alert_message.classList.contains('hidden')) {
      alert_message.classList.add('hidden');
      alert_message.classList.remove('error');
      alert_message.innerHTML = '';
    }
    submit_button.setAttribute("disabled", "disabled");
    submit_button.classList.add('is-loading');
    submit_button.querySelector(".btn__text").style.display = "none";
    
    fetch(zendesk_url.dataset.url, {
      method : "POST",
      headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(form_Data)
      }).then((response) => {
        if (response.status == 200) {
          wholesale_form.reset();
          alert_message.classList.remove('hidden');
          alert_message.innerHTML = "Thanks for contacting us. We'll get back to you as soon as possible.";
        } else {
          alert_message.classList.remove('hidden');
          alert_message.classList.add('error');
          alert_message.innerHTML = "Unable to process your request. Please try again later.";
        }
        setTimeout(() => {
          submit_button.classList.remove('is-loading');
          submit_button.querySelector(".btn__text").style.display = "block";
        }, 500);
        submit_button.removeAttribute("disabled");
      }).catch(function(error) {
        console.log(error);
      });
    });
};


const login_form = document.querySelector("form#customer_login");
if (login_form) {
  login_form.addEventListener("submit", (evt) => {
    evt.stopImmediatePropagation();
    evt.preventDefault();

    const form_data = $('form#customer_login').serialize();
    $('form#customer_login .form-errors').children().not('#login-email-error, #login-password-error').remove();
    $('#customer_login #login-email-error, #customer_login #login-password-error').empty();
    $('form#customer_login .form-errors').hide();
    $.post(login_form.action, form_data).done(function (data) {
      const responseErrors = $(data).find('form#customer_login').children();
      if (responseErrors.length > 0) {
        const errors = new Set();
        let errorsFound = false;
        $(data).find('.errors ul').children().each((index, item) => {
          if (item.innerHTML.includes("email")) {
            $('form#customer_login [name="customer[email]"').focus();
            $('form#customer_login .form-errors #login-email-error').text(item.innerHTML);
            errorsFound = true;
          } else {
            if (item.innerHTML.includes("password")) {
              $('form#customer_login [name="customer[password]"]').focus();
              $('form#customer_login .form-errors login-password-error').text(item.innerHTML);
              errorsFound = true;
            } else {
              // General error
              errors.add(`<span>${item.innerHTML}</span>`)
              errorsFound = true;
            }
          }
        })
        
        if (errorsFound) {
          if (errors.size > 0) {
            $('form#customer_login .form-errors').append([...errors].join('\n'))
          }
            $('form#customer_login .form-errors').show();
        }
      } else {
        document.location.href = login_form.return_url.value
      }
    });
  });
}

// 
const register_form = document.querySelector("form#create_customer");
if (register_form) {
  register_form.addEventListener("submit", (evt) => {
    evt.stopImmediatePropagation();
    evt.preventDefault();

    const form_data = $('form#create_customer').serialize();
    $('form#create_customer .form-errors').children().not('#register-first-name-error, #register-last-name-error, #register-email-error, #register-password-error').remove();
    $('#register-first-name-error, #register-last-name-error, #register-email-error, #register-password-error').empty();
    $('form#create_customer .form-errors').hide();
    $('form#create_customer .form-notification').hide();
    $('form#create_customer .form-notification').empty();

    $.post(register_form.action, form_data).done(function (data) {
      const hasErrors = $(data).find('form#create_customer .errors').length > 0
      if (hasErrors) {
        const existingAccountResponse = 'please click the link included to verify your email address.'
        let existingAccount = false;
        const errors = new Set()
        let errorFound = false
        $(data).find('form#create_customer .errors ul').children().each((index, item) => {
          if (item.textContent.includes(existingAccountResponse)){
            existingAccount = true;
          } else {
            errorFound = true
            const errorMsg = item.innerHTML.toLowerCase();
            if (errorMsg.includes("email") || errorMsg.includes("password") || errorMsg.includes("first name") || errorMsg.includes("last name")) {
              if (errorMsg.includes('first name')) {
                $('form#create_customer [name="customer[first_name]"').focus();
                $('form#create_customer .form-errors #register-first-name-error').text(item.innerHTML);
              }
              if (errorMsg.includes('last name')) {
                $('form#create_customer [name="customer[last_name]"').focus();
                $('form#create_customer .form-errors #register-last-name-error').text(item.innerHTML);
              }
              if (errorMsg.includes("email")) {
                $('form#create_customer [name="customer[email]"').focus();
                $('form#create_customer .form-errors #register-email-error').text(item.innerHTML);
              }
              if(errorMsg.includes("password")) {
                console.log('Password error handle')
                $('form#create_customer [name="customer[password]"]').focus();
                $('form#create_customer .form-errors #register-password-error').text(item.innerHTML);
              }
            } else {
              // General error
              errors.add(`<span>${item.innerHTML}</span>`)
            }
          }
        })

        if (existingAccount) {
            $('form#create_customer .form-notification').append(`<span>Your password has been set up for your existing account. We have sent an email to ${register_form.email.value}, please click the link included to verify your email address.</span>`);
            $('form#create_customer .form-notification').show();
        } else {
          if (errorFound) {
            if (errors.size > 0) {
              $('form#create_customer .form-errors').append([...errors].join('\n'))
            }
            $('form#create_customer .form-errors').show();
          }
        }
      } else {
        document.location.href = register_form.return_url.value
      }
    })
  });
};